// Module
var code = "<bg-splitter id=\"stimulus-response-splitter\" min-size=\"240\"><bg-pane-left><stimulus-media-display media=\"$ctrl.stimulusMedia\"></stimulus-media-display></bg-pane-left><bg-pane-right><session-media-display media=\"$ctrl.responseMedia\"></session-media-display></bg-pane-right></bg-splitter>";
// Exports
module.exports = code;